(() => {
  if (customElements.get('sk-delivery')) return;
  class SkDelivery extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section') || this.parentElement;
      this.current = this.querySelector('.sk-delivery__current');
      this.lastKey = null;
      this.onChange = () => {
        // Hide the previous variant's promise until the product form settles.
        this.paint('');
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => this.sync(), 100);
      };
      this.scope.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.scope, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['value', 'disabled']
      });
      // Some theme versions set input.value without dispatching a DOM event.
      this.timer = setInterval(() => {
        if (!document.hidden) this.sync();
      }, 500);
      this.sync();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.changeTimer);
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.onChange);
    }
    getInput() {
      if (this.dataset.formId) {
        return document.getElementById(this.dataset.formId)?.querySelector('[name="id"]') || null;
      }
      return this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
    }
    sync() {
      if (this.dataset.quoteMode === 'true') {
        // Quote products have no cart form. The quote form is updated by the
        // same variant picker and carries the selected variant explicitly.
        const quoteInput = this.scope.querySelector('.sk-shipping-quote [name="contact[Variant-ID]"]');
        const id = quoteInput ? String(quoteInput.value || '') : String(this.dataset.selectedId || '');
        this.paint(id);
        return;
      }
      const input = this.getInput();
      // Ordinary purchases still fail closed for missing/disabled variants.
      const id = input && !input.disabled ? String(input.value || '') : '';
      this.paint(id);
    }
    paint(id) {
      const templates = [...this.querySelectorAll('template[data-variant-id]')];
      const template = templates.find(t => t.dataset.variantId === id) || this.querySelector('template[data-fallback]');
      const key = template?.dataset.variantId || 'fallback';
      if (!template || !this.current || key === this.lastKey) return;
      this.lastKey = key;
      this.current.replaceChildren(template.content.cloneNode(true));
    }
  }
  customElements.define('sk-delivery', SkDelivery);
})();
